import { API_CONFIG } from '../config/api';
import { apiService } from './apiService';
import { mockService } from './mockService';

const STORAGE_KEY = 'shipments';

export const shipmentService = {
  async getAll(filters?: { status?: string; driverId?: string }) {
    if (API_CONFIG.USE_MOCK_API) {
      return mockService.get(STORAGE_KEY, (item: any) => {
        if (filters?.status && item.status !== filters.status) return false;
        if (filters?.driverId && item.assigned_driver_id !== filters.driverId) return false;
        return true;
      });
    } else {
      const params = new URLSearchParams();
      if (filters?.status) params.append('status', filters.status);
      if (filters?.driverId) params.append('driverId', filters.driverId);
      
      return await apiService.get(`/shipments?${params.toString()}`);
    }
  },

  async getById(id: string | number) {
    if (API_CONFIG.USE_MOCK_API) {
      return mockService.getById(STORAGE_KEY, id);
    } else {
      return await apiService.get(`/shipments/${id}`);
    }
  },

  async getOpenForBidding() {
    if (API_CONFIG.USE_MOCK_API) {
      return mockService.get(STORAGE_KEY, (item: any) => 
        item.status === 'open' && !item.assigned_driver_id
      );
    } else {
      return await apiService.get('/shipments/open-for-bidding');
    }
  },

  async create(data: any) {
    if (API_CONFIG.USE_MOCK_API) {
      const shipmentNo = String(Date.now());
      return mockService.create(STORAGE_KEY, {
        ...data,
        shipment_no: shipmentNo,
        status: 'open',
        current_stage: 0,
      });
    } else {
      return await apiService.post('/shipments', data);
    }
  },

  async update(id: string | number, data: any) {
    if (API_CONFIG.USE_MOCK_API) {
      return mockService.update(STORAGE_KEY, id, data);
    } else {
      return await apiService.put(`/shipments/${id}`, data);
    }
  },

  async delete(id: string | number) {
    if (API_CONFIG.USE_MOCK_API) {
      return mockService.delete(STORAGE_KEY, id);
    } else {
      return await apiService.delete(`/shipments/${id}`);
    }
  },

  async sendDriverMessage(id: string | number, message: string) {
    return await apiService.post(`/shipments/${id}/send-driver-message`, { message });
  },

  async addShipmentNote(id: string | number, note: string) {
    return await apiService.post(`/shipments/${id}/add-note`, { note });
  },

  async getRoute(id: string | number) {
    return await apiService.get(`/shipments/${id}/route`);
  },
};
